// Import dependencies
import GLightbox from 'glightbox';
import { initialiser } from '../../ramen-imports/utilitybelt';

class SingleImageLightbox {
  constructor(config) {
    const { el, settings } = config;

    this.image = el;
    this.settings = settings;
  }

  init = () => {
    const element = [{
      href: this.image.dataset.src,
      type: 'image',
      title: this.image.querySelector('img').alt || null,
    }];

    if (element[0].href) {
      const lightbox = GLightbox({
        elements: element,
      });

      this.image.addEventListener('click', () => lightbox.open());
    }
  };
}

export default (settings) => initialiser(settings, SingleImageLightbox);
